export default {
  URLS: {
    BASIC_SETTINGS:'/company/company-base-setting/',
  },
};
